import { Component, Input } from '@angular/core';
import { GridApi, Column, ColDef } from 'ag-grid-community';
import 'ag-grid-enterprise';
import { HttpService, CoreService } from '../../services';
import { CustomgridModel, CustomgridConfig, CustomgridParam } from '../../models';
import { ToastService } from '../../toast';
import { b64EncodeUnicode } from '../../utilities';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-customgrid-button',
  templateUrl: './customgrid-bouton-config.component.html',
  styleUrls: ['./customgrid-bouton-config.component.css']
})

export class CustomgridBoutonConfigComponent {
  public isLoading: boolean = false;
  public mode: string = 'SAVE';

  @Input() customgridName: string;
  @Input() class: string;
  @Input() grid: GridApi
  @Input('delete') set SetMode(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.mode = 'DELETE';
    } else {
      if (value) {
        this.mode = 'DELETE';
      }
    }
  }

  constructor(
    private indParam: CoreService,
    private http: HttpService,
    private toast: ToastService
  ) { }


  public SaveGrid(): void {
    if (this.isLoading) {
      this.toast.showInfoToast('La sauvegarde est déjà en cours.');
    }

    if (this.grid == null || this.grid.getColumnDefs == undefined || this.grid.getColumnDefs == null) {
      this.toast.showWarningToast('grid API incorect impossible de sauvegarder la configuration.');
    }
    if (!this.customgridName) {
      this.toast.showWarningToast('nom de la grid incorect impossible de sauvegarder la configuration.');
    }

    if (!this.isLoading && this.grid != null && this.grid.getColumnDefs != undefined && this.grid.getColumnDefs != null && this.customgridName) {
      this.isLoading = true;
      if (this.mode == 'SAVE') {
        const colDefs: ColDef[] = this.grid.getColumnDefs();

        if (colDefs.length < 1) {
          this.toast.showInfoToast('aucune colonne dans le tableau.');
          return;
        }

        const model: CustomgridModel = new CustomgridModel()
        model.cgParameters = new CustomgridParam();
        model.cgParameters.Mode = 'SAVE_CONFIG';
        model.ConfigGrid = new CustomgridConfig();
        model.ConfigGrid.Name = this.customgridName;
        model.ConfigGrid.parameters = colDefs;
        this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/customgrid/`, model).toPromise().then(() => { this.isLoading = false; });
      }
      else if (this.mode == 'DELETE')
      {
        const encodedCustomGridName = b64EncodeUnicode(this.customgridName);
        this.http.getHttp(`${this.indParam.AppParams.apiUrl}api/customgrid/getData/DELETE_CONFIG/${encodedCustomGridName}`).toPromise().then(() => { this.isLoading = false; });
      }
      else
      {
        this.isLoading = false;
      }
    }
  }
}
